import CommonContainer from "../../Container/CommonContainer";
import { FaToggleOn, FaToggleOff, FaPen } from "react-icons/fa";
import * as CaseLocationService from "../../../Services/Masters/CaseLocation/CaseLocationService";
import toast from "react-hot-toast";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

const CaseLocationComponent = () =>{

    const { register, handleSubmit, formState: { errors }, reset, } = useForm();

    const [caseLocationList, setCaseLocationList] = useState([]);
    const [selectedCaseLocation, setSelectedCaseLocation] = useState({});
    const [newCaseLocationModal, setNewCaseLocationModal] = useState(false);

    const fetchAllCaseLocationMasterList = () => {
        CaseLocationService.GetCaseLocationList()
          .then(({ data }) => {
            if (data.IsSuccess) {
              setCaseLocationList(data.Data);
            }
          })
          .catch(() => toast.error("Something went wrong."));
    };

    useEffect(() => {
        fetchAllCaseLocationMasterList();
        if (caseLocationList.length > 0) {
          //console.log("Updated caseLocationList:", caseLocationList);
        }
    },[]);

    const onSubmit = (data) => {
      //debugger;
      if (selectedCaseLocation?.LocationId) {
        data.LocationId = selectedCaseLocation?.LocationId;
        CaseLocationService.UpdateCaseLocation(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseLocationMasterList();
              toast.success("Case Location updated successfully!");
              handleNewCaseLocationModalClose();
            } else {
              toast.error("Something went wrong during update.");
            }
          })
          .catch(() => toast.error("Something went wrong during update."))
          .finally(() => { });
      } else {
        CaseLocationService.CreateNewCaseLocation(data)
          .then(({ data }) => {
            if (data.IsSuccess) {
              fetchAllCaseLocationMasterList();
              toast.success("Case Location saved successfully!");
              handleNewCaseLocationModalClose();
            } else {
              toast.error(data.ResponseMessage);
            }
          })
          .catch(() => toast.error("Something went wrong during creation."))
          .finally(() => { });
      }
    };

    const handleNewCaseLocationModalClose = () => {
      reset();
      setSelectedCaseLocation([]);
      setNewCaseLocationModal(false)
    };

    const handleActivateDeActivateCaseLocation = (rec) =>{
      CaseLocationService.ActivateDeActivateCaseLocation(rec.LocationId, !rec.IsActive).then(data => {
        if (data.data.IsSuccess) {
          const message = rec.IsActive ? "Case Location DeActivated Successfully" : "Case Location Activated Successfully";
          toast.success(message);
          fetchAllCaseLocationMasterList();
        } else {
          toast.error("Somthing went wrong");
        }
        //console.log("data", data)
      }).catch(error => {
        toast.error("Somthing went wrong");
      })
    }

    const handleViewCaseLocationDetailById = (LocationId) => {
      //debugger;
      const selectedItem = caseLocationList.find(item => item.LocationId === LocationId);
      if(selectedItem != null){
        setSelectedCaseLocation(selectedItem);
        setNewCaseLocationModal(true);
      }
      else{
        selectedCaseLocation({});
      }
    };

    return (
        <>
          {/* <LoadingSpinnerComponent></LoadingSpinnerComponent> */}
          <CommonContainer heading="Case Location List" buttonText="Add Case Location" onButtonClick={() => { reset(); setSelectedCaseLocation([]); setNewCaseLocationModal(true) }}>
    
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div className="d-flex align-items-center gap-2">
              </div>
              {/* <div className="search-box" style={{ position: "relative", width: "320px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  //ref={selectedSearchUser}
                  style={{
                    paddingRight: "35px",
                    borderRadius: "5px",
                    border: "1px solid #ddd",
                  }}
                />
                <button
                  type="button"
                  className="btn btn-success d-flex align-items-center justify-content-center"
                  style={{
                    padding: '5px',
                    position: "absolute",
                    right: "0px",
                    height: "35px",
                    width: "45px",
                    top: "50%",
                    borderTopLeftRadius: "0",
                    borderBottomLeftRadius: "0",
                    transform: "translateY(-50%)",
                  }}
                  //onClick={fetchUniversalFilterUserData}
                >
                  <FaSearch />
                </button>
    
              </div> */}
            </div>
            <div>
              <div className="table-responsive" >
                <table className="table table-bordered custom-table" >
                  <thead>
                    <tr>
                      <th> Case Location</th>
                      <th> Active </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      caseLocationList.length > 0 ? (
                        caseLocationList.map((rec, index) => (
                          <tr key={index} >
                            <td>{rec.LocationName}</td >
                            <td>
                              {rec.IsActive ? <FaToggleOn title="Deactivate CaseLocation" onClick={() => handleActivateDeActivateCaseLocation(rec)} color="green" size={16} /> : <FaToggleOff onClick={() => handleActivateDeActivateCaseLocation(rec)} title="Activate CaseLocation" color="red" size={16} />}
                            </td>
                            <td>
                              {/* <FaPenSquare color="green" className="mr-2 cursor-pointer" size={25} onClick={() => handleViewUserDetailById(rec.UserId)} title="Edit User" /> */}
                              <FaPen color="green" className="mr-2 cursor-pointer" onClick={() => handleViewCaseLocationDetailById(rec.LocationId)} title="Edit CaseLocation" />
                              {/* <FaTrash color={"red"} onClick={() => handleUserDelete(rec)} /> */}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="9" className="text-center" > No Data found </td></tr >
                      )}
                  </tbody>
                </table>
              </div>
            </div>

            {newCaseLocationModal && (
            <div className="modal-backdrop">
              <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg custom-modal" role="document">
                  <div className="modal-content mb-0 p-0">
                    <div className="modal-header p-2-5">
                      <h5 className="modal-title">{selectedCaseLocation?.CaseLocation ? "Edit Case Location" : "New Case Location"}</h5>
                      <button type="button" className="btn-close" onClick={handleNewCaseLocationModalClose}></button>
                    </div>
                    <div className="modal-body p-1">
                      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                        <div className="container mb-0" style={{ fontSize: "13px" }}>

                          <div className="row">

                            <div className="col-md-4 mb-2">
                              <label className="fw-bold required mb-0-5">Case Location</label>
                              <input type="text" className="form-control" placeholder="Enter Case Location" {...register("LocationName", { required: "Case Location is required" })} defaultValue={selectedCaseLocation?.LocationName || ""} />
                              {errors.CaseLocation && <p className="text-danger required_error">{errors.CaseLocation.message}</p>}
                            </div>
                          </div>
                        </div>

                        <div className="modal-footer mt-0 mb-0 pt-1 pb-0 pr-1">
                          <button type="button" className="btn btn-danger" onClick={handleNewCaseLocationModalClose}>Close</button>
                          <button type="submit" className="btn btn-primary">{selectedCaseLocation?.LocationId ? "Update" : "Save"}</button>
                        </div>

                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    
          </CommonContainer >
        </>
      );
}

export default CaseLocationComponent